import React, { useEffect, useState } from 'react';
import { FormGroup, Label, Input, Button } from 'reactstrap';
import moment from 'moment';
import qs from 'qs';
import { useSelector } from 'react-redux';
import { downloadFile, selectValues, sendFormEmail, validarCNPJ, validarCPF } from '../../../utils/fc';
import oikosApi from '../../../services/oikos';
import powerAppsApi from '../../../services/powerapps';
import { notifyError, notifySuccess } from '../../../utils/notify';
import ModalConfirmacao from '../ModalConfirmacao/ModalConfirmacao';
import AddFilesNoForm from '../../Template/Files/AddFilesNoForm';
import DatePicker from 'react-datepicker';
import {
  lookupFavorecidoByDocumento,
  normalizeDocumentoDigits,
} from '../ModalFormContrForn/contrFornCompraCotacaoInfo';
import { resolveBdroDtVencFromEvento } from '../ModalFormContrForn/contrFornEntregaveisUtils';
import {
  fetchDocumentoNfDoEvento,
  vincularDocumentoAoBdro,
} from '../ModalFormContrForn/contrFornNfDocumentos';
import { isMeioPagamentoDiretoCotacaoRapida, MEIO_PGTO } from '../../../pages/MeusFornecedores/contratosTabHelpers';

const EMPTY_FAVORECIDO_FORM = {
  documento: '',
  razao_social: '',
  telefone: '',
  email: '',
};

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());

const hasContrFornParte = (contrato = {}) => {
  const parteTab = String(contrato.contrForn_parteTab || '').trim().toLowerCase();
  const parteId = Number(contrato.contrForn_parteId) || 0;
  return (parteTab === 'pf' || parteTab === 'pj') && parteId > 0;
};

const getPixPayloadFromContrForn = (contrForn = {}, parteTab) => {
  if (Number(contrForn.meioPgto_id) !== MEIO_PGTO.PIX) return {};
  const pixTpId = Number(contrForn.pixTp_id) || 0;
  const chavePix = String(contrForn.contrForn_chavePix || '').trim();
  if (!pixTpId && !chavePix) return {};
  const tab = String(parteTab || '').trim().toLowerCase();
  return {
    ...(pixTpId ? { pixTp_id: pixTpId } : {}),
    ...(chavePix ? (tab === 'pf' ? { pf_chavePix: chavePix } : { pj_chavePix: chavePix }) : {}),
  };
};

/** Liberação especial (evidência + dtReal): meio PIX/Boleto/Cartão. Borderô só se tipo ≠ {1,5,14}. */
const isLiberacaoPagamentoDireto = (contrFornData = {}) => (
  isMeioPagamentoDiretoCotacaoRapida(contrFornData.meioPgto_id)
);

/** Tipos que liberam evento e enviam e-mail de NF (sem criar borderô), independente do meioPgto. */
const CONTR_FORN_TP_EMAIL_NF_IDS = [1, 5, 14];
const isContrFornTpEmailNf = (contrFornTpId) => (
  CONTR_FORN_TP_EMAIL_NF_IDS.includes(Number(contrFornTpId))
);

export const ButtonLiberarPagamento = (props) => {
  const [openModal, setOpenModal] = useState(false);
  const [openModalChangeDate, setOpenModalChangeDate] = useState(false);
  const [openModalFavorecido, setOpenModalFavorecido] = useState(false);
  const [favorecidoStep, setFavorecidoStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useSelector(state => state.auth);
  const [evidenciaFileContrFornEvento, setEvidenciaFileContrFornEvento] = useState([]);
  const [nfFileContrFornEvento, setNfFileContrFornEvento] = useState([]);
  const [nfJaVinculadaId, setNfJaVinculadaId] = useState(null);
  const [contrFornEventoData, setContrFornEventoData] = useState(props.contrFornEventoData);
  const [selectTipoPix, setSelectTipoPix] = useState([]);
  const [favorecidoForm, setFavorecidoForm] = useState(EMPTY_FAVORECIDO_FORM);
  const [favorecidoLookup, setFavorecidoLookup] = useState(null);
  const [contrFornDataState, setContrFornDataState] = useState(props.contrFornData || {});
  const [fornecedorState, setFornecedorState] = useState(props.fornecedor || {});

  useEffect(() => {
    setContrFornDataState(props.contrFornData || {});
  }, [props.contrFornData]);

  useEffect(() => {
    setFornecedorState(props.fornecedor || {});
  }, [props.fornecedor]);

  useEffect(() => {
    setContrFornEventoData(props.contrFornEventoData);
  }, [props.contrFornEventoData]);

  useEffect(() => {
    const eventoId = Number(props.contrFornEventoData?.contrFornEvento_id) || 0;
    if (!eventoId) {
      setNfJaVinculadaId(null);
      return;
    }
    let cancelled = false;
    fetchDocumentoNfDoEvento(eventoId).then((doc) => {
      if (!cancelled) setNfJaVinculadaId(Number(doc?.documento_id) || null);
    }).catch(() => {
      if (!cancelled) setNfJaVinculadaId(null);
    });
    return () => { cancelled = true; };
  }, [props.contrFornEventoData?.contrFornEvento_id]);

  const liberacaoPagamentoDireto = isLiberacaoPagamentoDireto(contrFornDataState);
  const isTipoEmailNf = isContrFornTpEmailNf(contrFornDataState.contrFornTp_id ?? props.contrFornData?.contrFornTp_id);
  /** PIX/Boleto/Cartão só criam bdro/gastoCartao se o tipo não for e-mail NF. */
  const liberacaoDiretaComBorderoOuCartao = liberacaoPagamentoDireto && !isTipoEmailNf;

  const checkCamposObrigatorios = () => {
    console.log('props', props);

    // Tipos 1/5/14 sempre enviam e-mail de NF — e-mail do fornecedor é obrigatório.
    if (!liberacaoPagamentoDireto || isTipoEmailNf) {
      if (!fornecedorState?.pf_id) {
        if (!fornecedorState?.pj_emailPrin || String(fornecedorState.pj_emailPrin).trim() === '') {
          notifyError('O fornecedor não possui e-mail. Contate o administrador do banco de dados.');
          return false;
        }
      }

      if (fornecedorState?.pf_id) {
        if (!fornecedorState?.pf_emailProf || String(fornecedorState.pf_emailProf).trim() === '') {
          notifyError('O fornecedor não possui e-mail. Contate o administrador do banco de dados.');
          return false;
        }
      }
    }

    const evidenciaObrigatoria = liberacaoPagamentoDireto || isTipoEmailNf;

    if (evidenciaFileContrFornEvento.length <= 0 && evidenciaObrigatoria) {
      notifyError('O campo Evidência é obrigatório.');
      return false;
    }
    return true;
  };

  const resetFavorecidoWizard = () => {
    setOpenModalFavorecido(false);
    setFavorecidoStep(1);
    setFavorecidoForm(EMPTY_FAVORECIDO_FORM);
    setFavorecidoLookup(null);
  };

  /** Returns true when favorecido (parte) already linked — caller may open evidência. */
  const ensureFavorecidoBeforeLiberar = async () => {
    if (hasContrFornParte(contrFornDataState)) {
      return true;
    }

    const contrFornId = Number(contrFornDataState?.contrForn_id) || 0;
    if (!contrFornId) {
      notifyError('Contrato não encontrado para informar o favorecido do pagamento.');
      return false;
    }

    setFavorecidoStep(1);
    setFavorecidoForm(EMPTY_FAVORECIDO_FORM);
    setFavorecidoLookup(null);
    setOpenModalFavorecido(true);
    return false;
  };

  const openEvidenciaModal = () => setOpenModal(true);

  const openLiberacaoAposDataOk = async () => {
    setIsLoading(true);
    try {
      const hasFavorecido = await ensureFavorecidoBeforeLiberar();
      if (hasFavorecido) openEvidenciaModal();
    } catch (error) {
      console.error(error);
      notifyError('Não foi possível verificar o favorecido do pagamento.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenModal = async () => {
   if (props.contrFornEventoData.contrFornEvento_dtPrev === null) {
     return notifyError('Data prevista não informada no evento.');
   }
    const today = new Date();
    const data = props.contrFornEventoData.contrFornEvento_dtPrev;

    // Convert "YYYY-MM-DD" to a local Date at midnight
    const [y, m, d] = data.split('-').map(Number)
    const target = new Date(y, m - 1, d)

    const isTodayBefore = today > target

    if (isTodayBefore) {
      return setOpenModalChangeDate(true);
    }

    return openLiberacaoAposDataOk();
  }

  const handleContinuarFavorecidoDocumento = async () => {
    const digits = normalizeDocumentoDigits(favorecidoForm.documento);
    if (!digits) {
      notifyError('Informe o CNPJ ou CPF do favorecido.');
      return;
    }
    if (!validarCPF(digits) && !validarCNPJ(digits)) {
      notifyError('CNPJ ou CPF inválido.');
      return;
    }

    setIsLoading(true);
    try {
      const lookup = await lookupFavorecidoByDocumento(digits);
      setFavorecidoLookup(lookup);

      if (lookup.existing) {
        if (lookup.tipo === 'pf') {
          setFavorecidoForm((prev) => ({
            ...prev,
            documento: digits,
            razao_social: lookup.existing.pf_nomeExibicao || lookup.existing.pf_nome || '',
            telefone: lookup.existing.pf_celProf || lookup.existing.pf_telFixoProf || '',
            email: lookup.existing.pf_emailProf || '',
          }));
        } else {
          setFavorecidoForm((prev) => ({
            ...prev,
            documento: digits,
            razao_social: lookup.existing.pj_razaosocial || lookup.existing.pj_nomefanta || '',
            telefone: lookup.existing.pj_telPrin || lookup.existing.pj_cel || '',
            email: lookup.existing.pj_emailPrin || '',
          }));
        }
      } else {
        setFavorecidoForm((prev) => ({
          ...prev,
          documento: digits,
          razao_social: '',
          telefone: '',
          email: '',
        }));
      }

      setFavorecidoStep(2);
    } catch (error) {
      console.error(error);
      notifyError(error?.message || 'Não foi possível consultar o CPF/CNPJ.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSalvarFavorecido = async () => {
    const razaoSocial = String(favorecidoForm.razao_social || '').trim();
    const telefone = String(favorecidoForm.telefone || '').trim();
    const email = String(favorecidoForm.email || '').trim();
    const digits = normalizeDocumentoDigits(favorecidoForm.documento || favorecidoLookup?.digits);
    const tipo = favorecidoLookup?.tipo;

    if (!razaoSocial) {
      notifyError('O campo Razão social ou Nome completo é obrigatório.');
      return;
    }
    if (!telefone) {
      notifyError('O campo Telefone é obrigatório.');
      return;
    }
    if (!email) {
      notifyError('O campo E-mail é obrigatório.');
      return;
    }
    if (!isValidEmail(email)) {
      notifyError('Informe um e-mail válido.');
      return;
    }
    if (!tipo || !digits) {
      notifyError('Documento do favorecido inválido. Volte e informe o CPF/CNPJ novamente.');
      return;
    }

    const contrFornId = Number(contrFornDataState?.contrForn_id) || 0;
    if (!contrFornId) {
      notifyError('Contrato não encontrado para vincular o favorecido.');
      return;
    }

    setIsLoading(true);
    try {
      let parteTab = tipo;
      let parteId = null;
      let pixSource = contrFornDataState;
      if (Number(pixSource.meioPgto_id) === MEIO_PGTO.PIX) {
        const resContrForn = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'contrForn',
          data: { contrForn_id: contrFornId },
        })}`);
        pixSource = {
          ...pixSource,
          ...(resContrForn?.data?.[0] || {}),
        };
      }
      const pixPayload = getPixPayloadFromContrForn(pixSource, tipo);

      if (favorecidoLookup?.existing) {
        if (tipo === 'pf') {
          parteId = Number(favorecidoLookup.existing.pf_id);
          await oikosApi.post('/', {
            action: 'update',
            table: 'pf',
            data: {
              pf_id: parteId,
              pf_nomeExibicao: razaoSocial,
              pf_nome: razaoSocial,
              pf_emailProf: email,
              pf_celProf: telefone,
              pf_usuarioMod: user?.pf_id,
              ...pixPayload,
            },
          });
        } else {
          parteId = Number(favorecidoLookup.existing.pj_id);
          await oikosApi.post('/', {
            action: 'update',
            table: 'pj',
            data: {
              pj_id: parteId,
              pj_razaosocial: razaoSocial,
              pj_nomefanta: razaoSocial,
              pj_emailPrin: email,
              pj_telPrin: telefone,
              pj_usuarioMod: user?.pf_id,
              ...pixPayload,
            },
          });
        }
      } else if (tipo === 'pf') {
        const insertRes = await oikosApi.post('/', {
          action: 'insert',
          table: 'pf',
          data: {
            pf_cpf: digits,
            pf_nomeExibicao: razaoSocial,
            pf_nome: razaoSocial,
            pf_emailProf: email,
            pf_celProf: telefone,
            pf_fornecedor: 1,
            pf_ativo: 1,
            pf_usuarioCria: user?.pf_id,
            pf_usuarioMod: user?.pf_id,
            ...pixPayload,
          },
        });
        parteId = Number(insertRes?.data?.[0]?.pf_id) || 0;
      } else {
        const insertRes = await oikosApi.post('/', {
          action: 'insert',
          table: 'pj',
          data: {
            pj_cnpj: digits,
            pj_razaosocial: razaoSocial,
            pj_nomefanta: razaoSocial,
            pj_emailPrin: email,
            pj_telPrin: telefone,
            pj_fornecedor: 1,
            pj_ativo: 1,
            pj_usuarioCria: user?.pf_id,
            pj_usuarioMod: user?.pf_id,
            ...pixPayload,
          },
        });
        parteId = Number(insertRes?.data?.[0]?.pj_id) || 0;
      }

      if (!parteId) {
        notifyError('Não foi possível obter o identificador do favorecido.');
        return;
      }

      await oikosApi.post('/', {
        action: 'update',
        table: 'contrForn',
        data: {
          contrForn_id: contrFornId,
          contrForn_parteTab: parteTab,
          contrForn_parteId: parteId,
        },
      });

      const nextContrForn = {
        ...contrFornDataState,
        contrForn_parteTab: parteTab,
        contrForn_parteId: parteId,
      };
      setContrFornDataState(nextContrForn);
      if (typeof props.onContrFornParteUpdated === 'function') {
        props.onContrFornParteUpdated(nextContrForn);
      }

      const nextFornecedor = parteTab === 'pf'
        ? {
          pf_id: parteId,
          pf_emailProf: email,
          pf_nomeExibicao: razaoSocial,
          pf_celProf: telefone,
          ...pixPayload,
        }
        : {
          pj_id: parteId,
          pj_emailPrin: email,
          pj_razaosocial: razaoSocial,
          pj_nomefanta: razaoSocial,
          pj_telPrin: telefone,
          ...pixPayload,
        };
      setFornecedorState(nextFornecedor);
      if (typeof props.setFornecedor === 'function') {
        props.setFornecedor(nextFornecedor);
      }

      resetFavorecidoWizard();
      openEvidenciaModal();
    } catch (error) {
      console.error(error);
      notifyError('Erro ao salvar o favorecido do pagamento.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirmFavorecido = async () => {
    if (favorecidoStep === 1) {
      return handleContinuarFavorecidoDocumento();
    }
    return handleSalvarFavorecido();
  };

  const fetchTiposDePix = async () => {
    try {
      const selectOptions = await selectValues('pixTp', 'pixTp_id', 'pixTp_nome');
      setSelectTipoPix(selectOptions);
    } catch (error) {
      console.log(error)
    }
  }

  const verificaDadosBancarios = (fornecedor) => {
    if (!fornecedor || typeof fornecedor !== "object") return true;

    // Possible field sets
    const pfFields = ["pf_contaBanco", "pf_contaAgencia", "pf_contaNum", "pf_chavePix", "pixTp_id"];
    const pjFields = ["pj_contaBanco", "pj_contaAgencia", "pj_contaNum", "pj_chavePix", "pixTp_id"];

    // Choose which set applies
    const fieldsToCheck = fornecedorState.hasOwnProperty("pf_contaBanco") ? pfFields : pjFields;

    // Check if any value is empty, null, or undefined
    return fieldsToCheck.some(field => {
      const value = fornecedor[field];
      return value === null || value === undefined || value === "";
    });
  };

    async function handleLiberarPagamento() {
    setIsLoading(true);
    if (!hasContrFornParte(contrFornDataState)) {
      setOpenModal(false);
      setIsLoading(false);
      await ensureFavorecidoBeforeLiberar();
      return;
    }
    const check = checkCamposObrigatorios();
    if (!check) return setIsLoading(false);
    try {
      // Upload Evidência document
      if (evidenciaFileContrFornEvento.length > 0) {
        // Cria um registro na tabela de documentos
        const documentBody = {
          action: 'insert',
          table: 'documento',
          data: {
            tpDocumento_id: 24,
            documento_desc: 'Evidência de evento fornecedor ' + props.contrFornEventoData.contrFornEvento_desc + ' ' + props.contrFornData.contrForn_desc,
            documento_iniVig: undefined,
            documento_fimVig: undefined,
            documento_dtEmissao: undefined,
            documento_prazo: undefined,
            documento_ref: undefined,
            privacidade_id: 2,
          },
        }
        const documentCreated = await oikosApi.post('/', documentBody)

        // Cria uma vinculação entre o termo de referência e o contrato
        if (documentCreated.data[0].documento_id) {
          const vinculationBodyContrFornEvento = {
            action: 'insert',
            table: 'documentoVinc',
            data: {
              documento_id: documentCreated.data[0].documento_id,
              documentoVinc_tabRef: 'contrFornEvento',
              documentoVinc_tabId: props.contrFornEventoData.contrFornEvento_id,
            },
          }
          await oikosApi.post('/', vinculationBodyContrFornEvento);
        }

        const formData = new FormData()
        formData.append('file', new Blob([evidenciaFileContrFornEvento[0].data], { type: evidenciaFileContrFornEvento[0].data.type }), evidenciaFileContrFornEvento[0].data.path)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'documento')
        formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
        formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
        formData.append('arquivo_desc', evidenciaFileContrFornEvento[0].data.path)

        await oikosApi.post('/', formData)
      }

      // Tipos 1/5/14: libera evento + e-mail NF (sem borderô), independente do meioPgto.
      if (isTipoEmailNf) {

        const dataForLinkNF = {
          title: props.contrFornData.contrForn_desc,
          id: fornecedorState.pf_id || fornecedorState.pj_id,
          dataLiberacao: moment().format('YYYY-MM-DD'),
          pixTp_id: fornecedorState.pixTp_id || null,
          bdro_vlr: props.contrFornEventoData.contrFornEvento_vlr,
          bdro_desc: props.contrFornEventoData.contrFornEvento_desc,
          contrFornEvento_pgtoPrazoDias: props.contrFornEventoData.contrFornEvento_pgtoPrazoDias,
          contrFornEvento_dtPrev: props.contrFornEventoData.contrFornEvento_dtPrev,
          bdro_tabRef: 'contrFornEvento',
          bdro_tabId: props.contrFornEventoData.contrFornEvento_id,
          bdro_favTab: fornecedorState.pf_id ? 'pf' : 'pj',
          orcItem_id: props.contrFornData.orcItem_id,
          [props.contrFornEventoData.contrFornEvento_dtPgtoFixa === 1 ? 'contrFornEvento_dtPgtoFixa' : '']: props.contrFornEventoData.contrFornEvento_dtPgtoFixa,
          [props.contrFornEventoData.contrFornEvento_vlrFixo === 1 ? 'contrFornEvento_vlrFixo' : '']: props.contrFornEventoData.contrFornEvento_vlrFixo,
          [props.contrFornData.contrForn_vlrFixo === 1 ? 'contrForn_vlrFixo' : '']: props.contrFornData.contrForn_vlrFixo,
          [props.contrFornData.contrForn_dtPgtoFixa === 1 ? 'contrForn_dtPgtoFixa' : '']: props.contrFornData.contrForn_dtPgtoFixa,
          contrFornTp_id: Number(props.contrFornData.contrFornTp_id),
        }

        const responseHashSecret = await powerAppsApi.post('/', {
          acao: 'cria_hash',
          payload: JSON.stringify({...dataForLinkNF})
        }, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'multipart/form-data',
          },
        });

        let data = {
          emailDest: fornecedorState.pj_emailPrin || fornecedorState.pf_emailProf,
          formLink: 'https://oikos.ecoss.is/oikos/formAnexaNF.php?h=' + responseHashSecret.data.payload_64 + '&s=' + responseHashSecret.data.sig_64,
          nomeDest: fornecedorState.pj_nomefanta || fornecedorState.pf_nomeExibicao,
          contrFornEvento_vlr: props.contrFornEventoData.contrFornEvento_vlr,
          contrFornEvento_desc: props.contrFornEventoData.contrFornEvento_desc,
          contrForn_desc: props.contrFornEventoData.contrForn_desc,
          corpo: '',
          emailEnvioTabRef: 'contrFornEvento',
          emailEnvioTabId: Number(props.contrFornEventoData.contrFornEvento_id),
        }

        sendFormEmail(data, 'Anexo de Nota Fiscal - Oikos');

        data = {
          ...data,
          emailDest: props.contrFornEventoData.pf_emailProf,
        }
        sendFormEmail(data, 'Anexo de Nota Fiscal - Oikos');

        const documentBody = {
          action: 'update',
          table: 'contrFornEvento',
          data: {
            contrFornEvento_id: props.contrFornEventoData.contrFornEvento_id,
            contrFornEvento_aprovLiberado: 1,
          },
        }
        const documentCreated = await oikosApi.post('/', documentBody)

        await props.getEventos({ includeArquivos: true });

        setIsLoading(false);
        setEvidenciaFileContrFornEvento([]);
        setOpenModal(false);
        return;
      }

      // PIX/Boleto/Cartão (tipo ≠ 1/5/14): evidência + liberação. Borderô só se não for Cartão.
      if (liberacaoDiretaComBorderoOuCartao) {
        const isMeioCartao = Number(contrFornDataState.meioPgto_id) === MEIO_PGTO.CARTAO;
        const parteTab = contrFornDataState.contrForn_parteTab || props.contrFornData?.contrForn_parteTab;
        const parteId = contrFornDataState.contrForn_parteId || props.contrFornData?.contrForn_parteId;
        let bdroId = null;

        if (!isMeioCartao) {
          const bdroBody = {
            action: 'insert',
            table: 'bdro',
            data: {
              bdro_vlr: props.contrFornEventoData.contrFornEvento_vlr || 0,
              bdro_dtVenc: resolveBdroDtVencFromEvento(props.contrFornEventoData),
              bdro_desc: `${props.contrFornEventoData.contrFornEvento_desc}` || undefined,
              bdro_favTab: parteTab || undefined,
              bdro_favId: parteId || undefined,
              orcItem_id: props.contrFornData.orcItem_id || contrFornDataState.orcItem_id || undefined,
              bdro_tabRef: 'contrFornEvento',
              bdro_tabId: props.contrFornEventoData.contrFornEvento_id || undefined,
            },
          };
          const bdroCreated = await oikosApi.post('/', bdroBody);
          bdroId = bdroCreated?.data?.[0]?.bdro_id || null;
          const nfDocId = nfJaVinculadaId || Number((await fetchDocumentoNfDoEvento(props.contrFornEventoData.contrFornEvento_id))?.documento_id) || 0;
          if (nfDocId && bdroId) {
            await vincularDocumentoAoBdro(nfDocId, bdroId);
          }
        } else {
          const contaId = Number(contrFornDataState.conta_id || props.contrFornData?.conta_id) || 0;
          if (!contaId) {
            notifyError('Cartão não informado no contrato. Não é possível registrar o gasto.');
            setIsLoading(false);
            return;
          }

          await oikosApi.post('/', {
            action: 'insert',
            table: 'gastoCartao',
            data: {
              conta_id: contaId,
              gastoCartao_valor: Number(props.contrFornEventoData.contrFornEvento_vlr) || 0,
              contrFornEvento_id: props.contrFornEventoData.contrFornEvento_id,
            },
          });
        }

        await oikosApi.post('/', {
          action: 'update',
          table: 'contrFornEvento',
          data: {
            contrFornEvento_id: props.contrFornEventoData.contrFornEvento_id,
            contrFornEvento_aprovLiberado: 1,
            contrFornEvento_dtReal: moment().format('YYYY-MM-DD'),
            ...(bdroId ? { bdro_id: bdroId } : {}),
          },
        });

        await props.getEventos({ includeArquivos: true });
        setIsLoading(false);
        setEvidenciaFileContrFornEvento([]);
        setOpenModal(false);
        notifySuccess('Pagamento liberado com sucesso!');
        return;
      }

      const nfDocExistenteId = nfJaVinculadaId
        || Number((await fetchDocumentoNfDoEvento(props.contrFornEventoData.contrFornEvento_id))?.documento_id)
        || 0;

      if (nfDocExistenteId) {
          const bdroBody = {
            action: 'insert',
            table: 'bdro',
            data: {
              bdro_vlr: props.contrFornEventoData.contrFornEvento_vlr || 0,
              bdro_dtVenc: resolveBdroDtVencFromEvento(props.contrFornEventoData),
              bdro_desc: `${props.contrFornEventoData.contrFornEvento_desc}` || undefined,
              bdro_favTab: props.contrFornData.contrForn_parteTab || undefined,
              bdro_favId: props.contrFornData.contrForn_parteId || undefined,
              orcItem_id: props.contrFornData.orcItem_id || undefined,
              bdro_tabRef: 'contrFornEvento',
              bdro_tabId: props.contrFornEventoData.contrFornEvento_id || undefined,
            },
          }
          const bdroCreated = await oikosApi.post('/', bdroBody);

          await oikosApi.post('/', {
            action: 'update',
            table: 'contrFornEvento',
            data: {
              contrFornEvento_id: props.contrFornEventoData.contrFornEvento_id,
              contrFornEvento_aprovLiberado: 1,
              bdro_id: bdroCreated.data[0].bdro_id,
            },
          });

          await vincularDocumentoAoBdro(nfDocExistenteId, bdroCreated.data[0].bdro_id);

          await props.getEventos({ includeArquivos: true });
          setIsLoading(false);
          setEvidenciaFileContrFornEvento([]);
          setOpenModal(false);
          notifySuccess('Pagamento liberado com sucesso!');
          return;
      }

      if (nfFileContrFornEvento.length > 0) {

          const bdroBody = {
            action: 'insert',
            table: 'bdro',
            data: {
              bdro_vlr: props.contrFornEventoData.contrFornEvento_vlr || 0,
              bdro_dtVenc: resolveBdroDtVencFromEvento(props.contrFornEventoData),
              bdro_desc: `${props.contrFornEventoData.contrFornEvento_desc}` || undefined,
              bdro_favTab: props.contrFornData.contrForn_parteTab || undefined,
              bdro_favId: props.contrFornData.contrForn_parteId || undefined,
              orcItem_id: props.contrFornData.orcItem_id || undefined,
              bdro_tabRef: 'contrFornEvento',
              bdro_tabId: props.contrFornEventoData.contrFornEvento_id || undefined,
            },
          }
          const bdroCreated = await oikosApi.post('/', bdroBody);

          const parcelaUpdateBody = {
            action: 'update',
            table: 'contrFornEvento',
            data: {
              contrFornEvento_id: props.contrFornEventoData.contrFornEvento_id,
              contrFornEvento_aprovLiberado: 1,
              bdro_id: bdroCreated.data[0].bdro_id,
            }
          }

          await oikosApi.post('/', parcelaUpdateBody);

          const documentNFBody = {
            action: 'insert',
            table: 'documento',
            data: {
              tpDocumento_id: 27,
              documento_desc: `Nota Fiscal ${props.contrFornEventoData.contrFornEvento_desc} ${props.contrFornData.contrForn_desc}`,
              documento_iniVig: undefined,
              documento_fimVig: undefined,
              documento_dtEmissao: undefined,
              documento_prazo: undefined,
              documento_ref: undefined,
              privacidade_id: 2,
            },
          }
          const documentNFCreated = await oikosApi.post('/', documentNFBody);

          console.log(props.contrFornEventoData.contrFornEvento_desc)
          console.log(props.contrFornData.contrForn_desc)

          const documentDocCobrancaBody = {
            action: 'insert',
            table: 'documento',
            data: {
              tpDocumento_id: 29,
              documento_desc: `Documento de cobrança ${props.contrFornEventoData.contrFornEvento_desc} ${props.contrFornData.contrForn_desc}`,
              documento_iniVig: undefined,
              documento_fimVig: undefined,
              documento_dtEmissao: undefined,
              documento_prazo: undefined,
              documento_ref: undefined,
              privacidade_id: 2,
            },
          }
          const documentDocCobrancaCreated = await oikosApi.post('/', documentDocCobrancaBody)

          if (documentNFCreated.data[0].documento_id) {
            let vinculationBody = {
              action: 'insert',
              table: 'documentoVinc',
              data: {
                documento_id: documentNFCreated.data[0].documento_id,
                documentoVinc_tabRef: 'contrFornEvento',
                documentoVinc_tabId: props.contrFornEventoData.contrFornEvento_id,
              },
            }
            await oikosApi.post('/', vinculationBody)

            vinculationBody = {
              action: 'insert',
              table: 'documentoVinc',
              data: {
                documento_id: documentNFCreated.data[0].documento_id,
                documentoVinc_tabRef: 'bdro',
                documentoVinc_tabId: bdroCreated.data[0].bdro_id,
              },
            }
            await oikosApi.post('/', vinculationBody);

            // Faz upload do arquivo e registra na tabela 'arquivo'
            const formData = new FormData()
            formData.append('file', new Blob([nfFileContrFornEvento[0].data], { type: nfFileContrFornEvento[0].data.type }), nfFileContrFornEvento[0].data.path)
            formData.append('table', 'arquivo')
            formData.append('action', 'upload_file')
            formData.append('arquivo_tabRef', 'documento')
            formData.append('arquivo_tabId', documentNFCreated.data[0].documento_id)
            formData.append('arquivo_privacidade', documentNFCreated.data[0].privacidade_id)
            formData.append('arquivo_desc', nfFileContrFornEvento[0].data.path)
            const fileUploadRes = await oikosApi.post('/', formData)
            console.tron.log('fileUploadRes', fileUploadRes)
          }

          // Cria uma vinculação entre o documento (anexo) e o registro da minuta
          if (documentDocCobrancaCreated.data[0].documento_id) {
            let vinculationBody = {
              action: 'insert',
              table: 'documentoVinc',
              data: {
                documento_id: documentDocCobrancaCreated.data[0].documento_id,
                documentoVinc_tabRef: 'contrFornEvento',
                documentoVinc_tabId: props.contrFornEventoData.contrFornEvento_id,
              },
            }
            await oikosApi.post('/', vinculationBody)

            vinculationBody = {
              action: 'insert',
              table: 'documentoVinc',
              data: {
                documento_id: documentDocCobrancaCreated.data[0].documento_id,
                documentoVinc_tabRef: 'bdro',
                documentoVinc_tabId: bdroCreated.data[0].bdro_id,
              },
            }
            await oikosApi.post('/', vinculationBody)

            // Faz upload do arquivo e registra na tabela 'arquivo'
            const formData = new FormData()
            formData.append('file', new Blob([nfFileContrFornEvento[0].data], { type: nfFileContrFornEvento[0].data.type }), nfFileContrFornEvento[0].data.path)
            formData.append('table', 'arquivo')
            formData.append('action', 'upload_file')
            formData.append('arquivo_tabRef', 'documento')
            formData.append('arquivo_tabId', documentDocCobrancaCreated.data[0].documento_id)
            formData.append('arquivo_privacidade', documentDocCobrancaCreated.data[0].privacidade_id)
            formData.append('arquivo_desc', nfFileContrFornEvento[0].data.path)
            const fileUploadRes = await oikosApi.post('/', formData)
            console.tron.log('fileUploadRes', fileUploadRes)
          }

          await props.getEventos({ includeArquivos: true });

          setIsLoading(false);
          setEvidenciaFileContrFornEvento([]);
          setOpenModal(false);
          notifySuccess('Pagamento liberado com sucesso!');
        } else {
          notifyError('O campo Nota Fiscal é obrigatório.');
          setIsLoading(false);
          return;
        }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }

  }

  async function handleUpdateEvento() {
    setIsLoading(true);
    const today = new Date();
    const data = contrFornEventoData.contrFornEvento_dtPrev;

    // Convert "YYYY-MM-DD" to a local Date at midnight
    const [y, m, d] = data.split('-').map(Number)
    const target = new Date(y, m - 1, d)

    console.log('today', today);
    console.log('target', target);

    const isTodayBefore = today > target
    if (isTodayBefore) {
      notifyError('A data prevista não pode ser anterior à data atual.');
      setIsLoading(false);
      return;
    }
    try {
      const res = await oikosApi.post('/', {
        action: 'update',
        table: 'contrFornEvento',
        data: {
          contrFornEvento_id: contrFornEventoData.contrFornEvento_id,
          contrFornEvento_dtPrev: contrFornEventoData.contrFornEvento_dtPrev,
        },
      })
      console.log('res', res);
      const listaParcelaAtualizada = await props.updateOneEvento(contrFornEventoData.contrFornEvento_id, String(props.contrFornData.contrForn_id));
      props.setListaParcelas(listaParcelaAtualizada);

      notifySuccess('Data prevista atualizada com sucesso!');
      setOpenModalChangeDate(false);
      setIsLoading(false);
      await openLiberacaoAposDataOk();
    } catch (error) {
      console.error(error);
    }
  }

  function getExtension(filename) {
    const idx = filename.lastIndexOf('.');
    return idx >= 0 ? filename.slice(idx + 1) : '';
  }

  const parcelaJaLiberada = Number(props.contrFornEventoData.contrFornEvento_aprovLiberado) === 1
    || (
      Number(props.contrFornEventoData.contrFornEvento_liberacaoAutomatica) === 1
      && Boolean(Number(props.contrFornEventoData.bdro_id))
    );

  return (
    <>
      {(!parcelaJaLiberada) ?
      <>
        <Button onClick={handleOpenModal} disabled={isLoading}>
          Liberar
        </Button>
        {openModalFavorecido && (
          <ModalConfirmacao
            openModal={openModalFavorecido}
            isLoading={isLoading}
            onConfirm={handleConfirmFavorecido}
            title="Favorecido do pagamento"
            text={favorecidoStep === 1
              ? 'Informe o CNPJ ou CPF do favorecido para continuar.'
              : (favorecidoLookup?.existing
                ? 'Confirme ou ajuste os dados do favorecido encontrado.'
                : 'Favorecido não encontrado. Preencha os dados para cadastrá-lo.')}
            onClosed={resetFavorecidoWizard}
            confirmButtonText={favorecidoStep === 1 ? 'Continuar' : 'Salvar'}
            secondaryButtonText={favorecidoStep === 2 ? 'Voltar' : undefined}
            onSecondary={favorecidoStep === 2 ? () => setFavorecidoStep(1) : undefined}
            childComponent={
              <div>
                {favorecidoStep === 1 ? (
                  <FormGroup>
                    <Label>CNPJ ou CPF</Label>
                    <Input
                      type="text"
                      placeholder="Somente números ou com pontuação"
                      value={favorecidoForm.documento || ''}
                      onChange={(e) => setFavorecidoForm({
                        ...favorecidoForm,
                        documento: e.target.value,
                      })}
                    />
                  </FormGroup>
                ) : (
                  <>
                    <FormGroup>
                      <Label>CNPJ ou CPF</Label>
                      <Input
                        type="text"
                        disabled
                        value={favorecidoForm.documento || ''}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Razão social ou Nome completo</Label>
                      <Input
                        type="text"
                        value={favorecidoForm.razao_social}
                        onChange={(e) => setFavorecidoForm({
                          ...favorecidoForm,
                          razao_social: e.target.value,
                        })}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Telefone</Label>
                      <Input
                        type="text"
                        value={favorecidoForm.telefone}
                        onChange={(e) => setFavorecidoForm({
                          ...favorecidoForm,
                          telefone: e.target.value,
                        })}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>E-mail</Label>
                      <Input
                        type="email"
                        value={favorecidoForm.email}
                        onChange={(e) => setFavorecidoForm({
                          ...favorecidoForm,
                          email: e.target.value,
                        })}
                      />
                    </FormGroup>
                  </>
                )}
              </div>
            }
          />
        )}
        {
          ((liberacaoDiretaComBorderoOuCartao || isTipoEmailNf) && !openModalChangeDate && !openModalFavorecido) ?
          <ModalConfirmacao
            openModal={openModal}
            isLoading={isLoading}
            onConfirm={handleLiberarPagamento}
            title="Confirma liberação para pagamento?"
            text="Essa ação é irreversível e informará ao setor financeiro para seguir o processo de pagamento."
            onClosed={() => setOpenModal(false)}
            childComponent={
              <div className="form-group">
                <span className="font-weight-bold">Evidência</span>
                <AddFilesNoForm
                  multiple={false}
                  files={evidenciaFileContrFornEvento}
                  onFilesChange={setEvidenciaFileContrFornEvento}
                />
              </div>
            }
          /> : ((!liberacaoDiretaComBorderoOuCartao && !isTipoEmailNf) && !openModalChangeDate && !openModalFavorecido) ?
          <ModalConfirmacao
            openModal={openModal}
            isLoading={isLoading}
            onConfirm={handleLiberarPagamento}
            title="Confirma liberação para pagamento?"
            text="Essa ação é irreversível e informará ao setor financeiro para seguir o processo de pagamento."
            onClosed={() => setOpenModal(false)}
            childComponent={
              <div className="form-group">
                <span className="font-weight-bold">Evidência</span>
                <AddFilesNoForm
                  multiple={false}
                  files={evidenciaFileContrFornEvento}
                  onFilesChange={setEvidenciaFileContrFornEvento}
                />
                {!nfJaVinculadaId && (
                  <>
                    <span className="font-weight-bold">Nota Fiscal</span>
                    <AddFilesNoForm
                      multiple={false}
                      files={nfFileContrFornEvento}
                      onFilesChange={setNfFileContrFornEvento}
                    />
                  </>
                )}
              </div>
            }
          /> : (openModalChangeDate) ?
            <ModalConfirmacao
              openModal={openModalChangeDate}
              isLoading={isLoading}
              onConfirm={() => handleUpdateEvento()}
              title="Data prevista ultrapassada"
              text="A data prevista para este evento já passou. Por favor, atualize a data prevista antes de liberar o pagamento."
              onClosed={() => setOpenModalChangeDate(false)}
              childComponent={
                <div>
                  <FormGroup>
                    <Label>
                      Nova data prevista p/ realização do pagamento
                    </Label>
                    <DatePicker
                      placeholderText="__/__/_____"
                      locale="pt-BR"
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      popperContainer={()=><></>}
                      dropdownMode="select"
                      selected={contrFornEventoData.contrFornEvento_dtPrev ? moment(contrFornEventoData.contrFornEvento_dtPrev).toDate() : null}
                      onChange={date => {
                        setContrFornEventoData({...contrFornEventoData, contrFornEvento_dtPrev: date ? moment(date).format('YYYY-MM-DD') : null});
                      }}
                    />
                  </FormGroup>
                </div>
              }
            /> :
          <></>
        }
      </>
      :
      <>
        <div className="d-flex flex-column justify-content-center align-items-center">
          <span className="text-success">Liberado</span>
          {props.contrFornEventoData.arquivo_caminho_evidencia &&
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                downloadFile(
                  `https://oikos.ecoss.is/oikos/${props.contrFornEventoData.arquivo_caminho_evidencia}`,
                  `Evidencia Evento ${props.contrFornEventoData.contrFornEvento_desc}.${getExtension(props.contrFornEventoData.arquivo_caminho_evidencia)}`
                );
              }}
            >
              Evidência
            </a>
          }
          {props.contrFornEventoData.arquivo_caminho_nota_fiscal &&
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                downloadFile(
                  `https://oikos.ecoss.is/oikos/${props.contrFornEventoData.arquivo_caminho_nota_fiscal}`,
                  `Nota Fiscal Evento ${props.contrFornEventoData.contrFornEvento_desc}.${getExtension(props.contrFornEventoData.arquivo_caminho_nota_fiscal)}`
                );
              }}
            >
              Nota Fiscal
            </a>
          }
          <Button onClick={async () => {
        const dataForLinkNF = {
          title: props.contrFornData.contrForn_desc,
          id: fornecedorState.pf_id || fornecedorState.pj_id,
          dataLiberacao: moment().format('YYYY-MM-DD'),
          contrFornEvento_dtPrev: props.contrFornEventoData.contrFornEvento_dtPrev,
          contrFornEvento_pgtoPrazoDias: props.contrFornEventoData.contrFornEvento_pgtoPrazoDias,
          [props.contrFornEventoData.contrFornEvento_dtPgtoFixa === 1 ? 'contrFornEvento_dtPgtoFixa' : '']: props.contrFornEventoData.contrFornEvento_dtPgtoFixa,
          [props.contrFornEventoData.contrFornEvento_vlrFixo === 1 ? 'contrFornEvento_vlrFixo' : '']: props.contrFornEventoData.contrFornEvento_vlrFixo,
          [props.contrFornData.contrForn_dtPgtoFixa === 1 ? 'contrForn_dtPgtoFixa' : '']: props.contrFornData.contrForn_dtPgtoFixa,
          [props.contrFornData.contrForn_vlrFixo === 1 ? 'contrForn_vlrFixo' : '']: props.contrFornData.contrForn_vlrFixo,
          contrFornTp_id: Number(props.contrFornData.contrFornTp_id),
          pixTp_id: fornecedorState.pixTp_id || null,
          bdro_vlr: props.contrFornEventoData.contrFornEvento_vlr,
          bdro_desc: props.contrFornEventoData.contrFornEvento_desc,
          bdro_tabRef: 'contrFornEvento',
          bdro_tabId: props.contrFornEventoData.contrFornEvento_id,
          bdro_favTab: fornecedorState.pf_id ? 'pf' : 'pj',
          orcItem_id: props.contrFornData.orcItem_id
        }

        const responseHashSecret = await powerAppsApi.post('/', {
          acao: 'cria_hash',
          payload: JSON.stringify({...dataForLinkNF})
        }, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'multipart/form-data',
          },
        });

        const link = 'https://oikos.ecoss.is/oikos/formAnexaNF.php?h=' + responseHashSecret.data.payload_64 + '&s=' + responseHashSecret.data.sig_64;
        navigator.clipboard.writeText(link);
        notifySuccess('Link copiado para a área de transferência!');
      }}>Copiar link</Button>
        </div>
      </>
      }
    </>
  );
};
